import { Helmet } from 'react-helmet-async';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Stack, Box } from '@mui/material';
import { url } from 'src/apiUtils/apiPath';
import { appApi } from 'src/apiUtils/AppApi';
import { useEffect, useState } from 'react';
import {
  TodaysBooking,
  DashboardCount,
  BookingOverall,
  PaymentListDetails,
  BookingListDetails,
  ExpertListDetail
} from '../sections/@dashboard/app';
import config from '../AppConfig'

export default function DashboardAppPage() {
  const theme = useTheme();
  const [userDtl, setUserDtl] = useState(JSON.parse(localStorage.getItem("userLoginDetail")))
  const [dashCard, setDashCard] = useState([])
  const [chartLabels, setChartLabels] = useState([])
  const [chartData, setChartData] = useState([])
  const [chartBarLabel, setChartBarLabel] = useState([])
  const [chartPlotData, setChartPlotData] = useState([])
  const [pieData, setPieData] = useState([])
  useEffect(() => {
    appApi(`${url.DASHBOARD_TODAY_BOOKING}`, "POST", {}, JSON.stringify({})).then((result) => {
      if (result.status) {
        console.log(result.data)
        const chartPlot = [{
          name: 'Bookings',
          type: 'bar',
          fill: 'solid',
          data: result.data.data.map((e) => { return e.count })
        }]
        console.log('chartPlot', chartPlot)
        const pieDataList = result.data.upcomingData.map((e, index) => {
          return { id: index, value: e.count, label: e._id }
        })
        console.log(pieDataList)
        setPieData(pieDataList)
        setChartPlotData(chartPlot);
        setChartBarLabel(result.data.data.map((e) => { return e._id }))
      }
    })

    appApi(`${url.DASHBOARD_COUNT_DATA}`, "GET", {}).then((result) => {
      if (result.status) {
        setDashCard(result.data)
      }
    })
  }, [])

  const dashboarData = [

    {
      title: "Overall Booking",
      total: dashCard?.overallBookings ? parseInt(dashCard?.overallBookings, 10) : 0,
      color: "error",
      icon: 'mingcute:book-2-line',
      navigateUrl: '/admin/booking'
    },
    {
      title: "Todays Booking",
      total: dashCard?.bookingCount ? parseInt(dashCard?.bookingCount, 10) : 0,
      icon: 'mingcute:book-2-line',
      navigateUrl: '/admin/booking'
    },

    {
      title: `Total ${config.appUserType}`,
      total: dashCard?.celebrityCount ? parseInt(dashCard?.celebrityCount, 10) : 0,
      color: "warning",
      icon: 'mingcute:user-4-line',
      navigateUrl: '/admin/studio'
    },
    {
      title: "Total Users",
      total: dashCard?.userCount ? parseInt(dashCard?.userCount, 10) : 0,
      color: "info",
      icon: 'mingcute:group-3-line',
      navigateUrl: '/admin/users'
    }
  ]


  return (
    <>
      <Helmet>
        <title> Dashboard </title>
      </Helmet>

      <Container maxWidth="xl">

        <Grid container spacing={2}>
          {dashboarData.map((data) =>
            <Grid item xs={12} sm={6} md={3}>
              <DashboardCount title={data.title} total={data.total ?? 0} color={data.color} icon={data.icon} navigateUrl={data.navigateUrl} />
            </Grid>
          )}
          <Grid item xs={7.5} sm={7.5} md={7.5} lg={7.5} xl={7.5}>
            <Stack direction={'column'}>
              <Box>
                <BookingOverall
                  title="Overall Booking"
                  chartLabels={chartLabels}
                  chartData={chartData}
                />
              </Box>
              <Box sx={{ marginTop: 2 }}>
                <TodaysBooking
                  title="Today's Booking"
                  chartLabels={chartBarLabel}
                  chartData={chartPlotData}
                />
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={4.5} sm={4.5} md={4.5} lg={4.5} xl={4.5}>
            <Stack direction={'column'}>
              <Box>
                <ExpertListDetail
                  title="Upcoming Booking Details"
                  borderColor={"error"}
                  pieDataList ={pieData}
                />
              </Box>
              <Box sx={{ marginTop: 1 }}>
                <BookingListDetails
                  title="Todays Booking List"
                  borderColor={"success"}
                />
              </Box>
              <Box sx={{ marginTop: 1 }}>
                <PaymentListDetails
                  title="Transaction Details"
                  borderColor={"info"}
                />
              </Box>
            </Stack>

          </Grid>

        </Grid>
      </Container >
    </>
  );
}
